import { render, staticRenderFns } from "./Synchronization.vue?vue&type=template&id=795b7b9e"
import script from "./Synchronization.vue?vue&type=script&lang=js"
export * from "./Synchronization.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports